import { FetchRequest } from "./fetchRequest";

class UrlFetch {
  fetchRSS(body) {
    return FetchRequest({
      url: "/ssp/sendings/rss/fetch",
      method: "POST",
      useToken: true,
      body,
    });
  }
  fetchURL(linkPreviewUrl) {
    return FetchRequest({
      url: `https://notix.io/preview?url=${linkPreviewUrl}`,
      method: "GET",
    });
  }
}

const urlFetchInstance = new UrlFetch();

export default urlFetchInstance;